module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 58);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("@tencent/e-zepto");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Component; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3__);




var Component = /*#__PURE__*/function () {
  function Component(select) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Component);
    var selector = select;
    var opts = options;

    /**
     * 如果第一个参数selector 是Object，并且是非 dom对象，则直接赋值给 opts
     * 支持selector参数为dom对象，此时selector为Object, 但selector.length=1不会被下方格式化
     */
    if (Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3__["isObject"])(selector) && !selector.length) {
      opts = selector;
      selector = '';
    }
    this.selector = selector;
    this.options = opts;
    this.plugins = [];
    this.$container = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default()(selector);
    this.$renderDom = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default()(this.render());
    this.$containerDom = this.$renderDom.length > 0 ? this.$renderDom : this.$container;
    this.$container && this.$container.append(this.$renderDom);
  }

  /**
   * 注册子组件
   * @param  {...any} plugins
   */
  return _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Component, [{
    key: "registerChild",
    value: function registerChild(plg) {
      var plugin = plg;
      var _plugin$container = plugin.container,
        container = _plugin$container === void 0 ? '' : _plugin$container;
      var comps = plugin.comps;
      if (Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3__["isObject"])(comps)) {
        comps = [comps];
      }
      comps.forEach(function (item) {
        var comp = item;
        comp.$container = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default()(container);
        comp.$containerDom = comp.$container;
        if (!comp.$renderDom && Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_3__["isFunction"])(comp.render)) {
          comp.$renderDom = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default()(comp.render());
        }
        comp.$container.append(comp.$renderDom);
        comp.action && comp.action(comp);
      });
      plugin.comps = comps;
    }

    /**
     * 实例单独注册组件
     */
  }, {
    key: "register",
    value: function register() {
      var _this = this;
      for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }
      this.plugins = plugins;
      plugins.forEach(function (plugin) {
        if (!plugin) {
          return;
        }
        _this.registerPlugins(plugin);
      });
    }

    /**
     * 注册插件
     * @param {*} plugin
     */
  }, {
    key: "registerPlugins",
    value: function registerPlugins(plugin) {
      // 如果注册的是 comps
      var comps = plugin.comps;
      if (comps) {
        this.registerChild(plugin);
        return;
      }
      var html = plugin.render(this);
      var $containerDom = this.$containerDom;
      if (this.$renderDom.length) {
        $containerDom = this.$renderDom;
      }
      if (plugin.container) {
        $containerDom = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_2___default()(plugin.container);
      }
      $containerDom.append(html);
      plugin.action && plugin.action(plugin);
    }
  }, {
    key: "render",
    value: function render() {
      return '';
    }

    /**
     * 默认销毁方法
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyPlugin();
      if (this.$renderDom) {
        this.$renderDom.off();
        this.$renderDom.remove();
        this.$renderDom = null;
      }
    }

    /**
     * 销毁注册的插件
     */
  }, {
    key: "destroyPlugin",
    value: function destroyPlugin() {
      var _this2 = this;
      this.plugins.forEach(function (plugin) {
        _this2.destroyComps(plugin);
        plugin.destroy && plugin.destroy();
      });
    }

    /**
     * 销毁组件
     */
  }, {
    key: "destroyComps",
    value: function destroyComps(plugin) {
      var _plugin$comps = plugin.comps,
        comps = _plugin$comps === void 0 ? [] : _plugin$comps;
      comps.forEach(function (comp) {
        comp.destroy && comp.destroy();
      });
    }
  }]);
}();


/***/ })

/******/ })["default"];